import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginSessionAvailable } from "../features/auth/authSlice";
import { useTokenValidation } from "../hooks/useTokenValidation";
import AuthPage from "../features/auth/AuthPage";

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated, tokenExpired } = useSelector((state) => state.auth);
  const { validateToken } = useTokenValidation();

  useEffect(() => {
    // Check session on component mount
    dispatch(loginSessionAvailable());
  }, [dispatch]);

  // If token expired or not authenticated, show login
  if (!isAuthenticated || tokenExpired) {
    return <AuthPage />;
  }

  return children;
};

export default ProtectedRoute;
